import { navigate } from 'hookrouter'
import { useTemplatesForProject } from 'hooks/useTemplatesForProject'
import React, { FC, useEffect } from 'react'
import { ListGroup } from 'react-bootstrap'
import { TemplateDocument, UrlParams, ActionParams } from 'types'
import { useAppContext } from 'state/context'
import { LoadMoreButton } from 'components/LoadMoreButton'
import { shouldProvideLoadMore } from 'utils/loadMoreHelpers'
import { nextPageNumber } from 'utils/loadMoreHelpers'
import { fetchTemplateDocuments, getPermissionsList } from 'state/async_actions'
import { Button } from 'react-bootstrap'
import { usePermissions } from 'hooks/useCompanyManagers'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
// import { usePermissions } from 'hooks/useCompanyManagers'
// import { useUser } from 'hooks/useCompany'

export const newTemplatePath = (companyId: number, projectId: number) =>
  `/company/${companyId}/project/${projectId}/new_template_document`

export const newTemplateDirectoryPath = (
  companyId: number,
  projectId: number,
  directoryId?: number | undefined,
) =>
  `/company/${companyId}/project/${projectId}/directory/${directoryId}/new_template_document`

export const newTemplateSubDirectoryPath = (
  companyId: number,
  projectId: number,
  directoryId?: number | undefined,
  subDirectoryId?: number | undefined,
) =>
  `/company/${companyId}/project/${projectId}/directory/${directoryId}/subDirectory/${subDirectoryId}/new_template_document`

export const newFolderPath = (companyId: number, projectId: number) =>
  `/company/${companyId}/project/${projectId}/new_folder`

export const folderPath = (
  companyId: number,
  projectId: number,
  templateDocumentId?: number | undefined,
) => {
  return `/company/${companyId}/project/${projectId}/directory/${templateDocumentId}`
}

export const subFolderPath = (
  companyId: number,
  projectId: number,
  templateDocumentId?: number | undefined,
  templateSubDocumentId?: number | undefined,
) => {
  return `/company/${companyId}/project/${projectId}/directory/${templateDocumentId}/subFolder/${templateSubDocumentId}`
}

export const addNewTemplateLinkText = 'New Template Document'
export const addNewFolderLinkText = 'Add New Folder'

type ProjectTemplatesListProps = {
  onClick: (template: TemplateDocument) => void
  activeTemplate?: TemplateDocument
  template_directory_id?: number
  template_sub_directory_id?: number | undefined
} & UrlParams &
  ActionParams
export const ProjectTemplatesList: FC<ProjectTemplatesListProps> = ({
  activeTemplate,
  onClick,
  companyId,
  projectId,
  template_directory_id,
  template_sub_directory_id,
  hideActions,
}) => {
  let userRoleType: any = 1
  const [, dispatch] = useAppContext()

  const localTemplates = useTemplatesForProject(projectId)
  const projectList = useProjectsForCompany(companyId)
  const selectedProject: any =
    projectList.find((company: any) => company.id === projectId) || {}

  if (selectedProject.isCompanyManager) userRoleType = 1
  else if (selectedProject.isProjectManager) userRoleType = 2
  else if (selectedProject.isProjectCoordinator) userRoleType = 5
  else if (selectedProject.isSuperForeman) userRoleType = 3
  else if (selectedProject.isSubCordinator) userRoleType = 4

  useEffect(() => {
    if (companyId) getPermissionsList(dispatch, companyId, userRoleType)
  }, [dispatch, projectId, userRoleType])

  const permissionsList: any = usePermissions(userRoleType)

  const setAsActiveTemplate = (template: TemplateDocument) => () =>
    onClick(template)

  const isActive = (template: TemplateDocument) => {
    if (activeTemplate) {
      return activeTemplate.id === template.id
    }
    return false
  }

  const navToNewTemplateDocument = () => {
    if (template_sub_directory_id)
      return navigate(
        newTemplateSubDirectoryPath(
          companyId,
          projectId,
          template_directory_id,
          template_sub_directory_id,
        ),
      )
    else if (template_directory_id && !template_sub_directory_id)
      return navigate(
        newTemplateDirectoryPath(companyId, projectId, template_directory_id),
      )
    else return navigate(newTemplatePath(companyId, projectId))
  }

  const navToNewFolderCreation = () =>
    navigate(newFolderPath(companyId, projectId))

  const navToDirectory = (templateDocumentId: number, template: any) => {
    localStorage.setItem('parentDirectory', JSON.stringify(template))
    return navigate(folderPath(companyId, projectId, templateDocumentId))
  }

  const navToSubDirectory = (
    templateDocumentId: number,
    templateSubDocumentId?: number,
    template?: any,
  ) => {
    localStorage.setItem('subDirectory', JSON.stringify(template))
    return navigate(
      subFolderPath(
        companyId,
        projectId,
        templateDocumentId,
        templateSubDocumentId,
      ),
    )
  }

  const loadMore = () => {
    const nextPage = nextPageNumber(localTemplates)

    fetchTemplateDocuments(
      dispatch,
      projectId,
      template_sub_directory_id
        ? template_sub_directory_id
        : template_directory_id,
      nextPage,
      localTemplates
    )
  }
  return (
    <>
      <div>
        {localTemplates.length ? (
          <div style={{ width: '128%' }}>
            <div>
              <h3 style={{ fontSize: '21px' }}>Manage Templates/Folders</h3>
            </div>
            <ListGroup as="ul" style={{ minHeight: '153px', maxHeight: '400px', overflowY: 'scroll' }}>
              {localTemplates.map(template => {
                return (
                  template.isDirectory && (
                    <ListGroup.Item
                      as="li"
                      active={isActive(template)}
                      key={template.id}
                      onClick={() => {
                        return template_directory_id
                          ? navToSubDirectory(
                            template_directory_id,
                            template.id,
                            template,
                          )
                          : navToDirectory(template.id, template)
                      }}>
                      <img
                        alt="img"
                        style={{ height: '20px', width: '20px' }}
                        src="https://www.clipartmax.com/png/small/364-3646106_240-%C3%97-240-pixels-folder-icon-flat-svg.png"
                      />
                      <span style={{ padding: '10px' }}>{template.name}</span>
                      <svg
                        className="svg-icon"
                        viewBox="0 0 20 20"
                        style={{
                          width: '17px',
                          marginTop: '4px',
                          float: 'right',
                        }}>
                        <path d="M12.522,10.4l-3.559,3.562c-0.172,0.173-0.451,0.176-0.625,0c-0.173-0.173-0.173-0.451,0-0.624l3.248-3.25L8.161,6.662c-0.173-0.173-0.173-0.452,0-0.624c0.172-0.175,0.451-0.175,0.624,0l3.738,3.736C12.695,9.947,12.695,10.228,12.522,10.4 M18.406,10c0,4.644-3.764,8.406-8.406,8.406c-4.644,0-8.406-3.763-8.406-8.406S5.356,1.594,10,1.594C14.643,1.594,18.406,5.356,18.406,10M17.521,10c0-4.148-3.374-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.147,17.521,10"></path>
                      </svg>
                      {/* <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg> */}
                    </ListGroup.Item>
                  )
                )
              })}
              {localTemplates.map(template => {
                return (
                  !template.isDirectory && (
                    <ListGroup.Item
                      as="li"
                      active={isActive(template)}
                      key={template.id}
                      onClick={setAsActiveTemplate(template)}>
                      <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        clip-rule="evenodd">
                        <path d="M22 24h-20v-24h14l6 6v18zm-7-23h-12v22h18v-16h-6v-6zm3 15v1h-12v-1h12zm0-3v1h-12v-1h12zm0-3v1h-12v-1h12zm-2-4h4.586l-4.586-4.586v4.586z" />
                      </svg>
                      <span style={{ padding: '10px' }}>{template.title}</span>
                      <svg
                        className="svg-icon"
                        viewBox="0 0 20 20"
                        style={{
                          width: '17px',
                          marginTop: '4px',
                          float: 'right',
                        }}>
                        <path d="M12.522,10.4l-3.559,3.562c-0.172,0.173-0.451,0.176-0.625,0c-0.173-0.173-0.173-0.451,0-0.624l3.248-3.25L8.161,6.662c-0.173-0.173-0.173-0.452,0-0.624c0.172-0.175,0.451-0.175,0.624,0l3.738,3.736C12.695,9.947,12.695,10.228,12.522,10.4 M18.406,10c0,4.644-3.764,8.406-8.406,8.406c-4.644,0-8.406-3.763-8.406-8.406S5.356,1.594,10,1.594C14.643,1.594,18.406,5.356,18.406,10M17.521,10c0-4.148-3.374-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.147,17.521,10"></path>
                      </svg>
                    </ListGroup.Item>
                  )
                )
              })}
              {shouldProvideLoadMore(localTemplates) ? (
                <LoadMoreButton onClick={loadMore} />
              ) : null}
            </ListGroup>
            <br />
          </div>
        ) : null}
      </div>
      <div>
        {!hideActions ? (
          <div style={{ width: '128%' }}>
            {permissionsList?.template_document?.can_create &&
              selectedProject?.status == 'active' && (
                <Button
                  className="mb-3 btn-icon-plus"
                  onClick={navToNewTemplateDocument}
                  block>
                  {addNewTemplateLinkText}
                </Button>
              )}
            {permissionsList?.template_document?.create_folder_within_project &&
              selectedProject?.status == 'active' && (
                <Button
                  className="mb-3 btn-icon-plus"
                  onClick={navToNewFolderCreation}
                  block>
                  {addNewFolderLinkText}
                </Button>
              )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  )
}
